import { createFileRoute } from '@tanstack/react-router'
import { NewProposalForm } from '@/components/proposal/NewProposalForm'
import { useProjectBreadcrumb } from '@/common/useProjectBreadcrumb'
import { PageHeader } from '@/components/PageHeader'
import { getProposalDefaultTemplate } from '@/api/documentAgent/documentAgent'

export const Route = createFileRoute('/_auth/$orgSlug/$projectId/proposal-agent/')({
  loader: getProposalDefaultTemplate,
  head: () => ({ meta: [{ title: 'Proposal Agent - Snowvault' }] }),
  component: ProposalAgentIndex
})

function ProposalAgentIndex() {
  const { orgSlug, projectId } = Route.useParams()
  const { template } = Route.useLoaderData()
  const { projectTitle, projectTo } = useProjectBreadcrumb()
  return (
    <>
      <PageHeader breadcrumbs={[{ label: projectTitle, to: projectTo }, { label: 'Proposal Agent' }]} />
      <div className="flex flex-1 flex-col items-center justify-center overflow-y-scroll p-6">
        <NewProposalForm projectId={parseInt(projectId, 10)} orgSlug={orgSlug} defaultTemplate={template} />
      </div>
    </>
  )
}
